import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 p-2 flex justify-content-between" }
const _hoisted_2 = { class: "p-0 text-sm font-semibold" }
const _hoisted_3 = { class: "p-0 font-light" }
const _hoisted_4 = { class: "m-0 text-justify word-wrap-break" }
const _hoisted_5 = ["innerHTML"]

import UserLink from "@/components/UserLink.vue";
import { Comment } from "@/models/comment";
import { useAuth0 } from "@auth0/auth0-vue";
import PostOptionButton from "./CommentOptionButton.vue"


export default /*#__PURE__*/_defineComponent({
  props: {
    comment: null
  },
  emits: ["delete-click"],
  setup(__props: any, { emit }) {





const { user } = useAuth0();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(UserLink, {
          username: __props.comment?.user.username,
          id: __props.comment?.user.id,
          class: "font-semibold"
        }, null, 8, ["username", "id"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("span", {
            innerHTML: __props.comment?.content
          }, null, 8, _hoisted_5)
        ])
      ])
    ]),
    (__props.comment.user.id === _unref(user).sub)
      ? (_openBlock(), _createBlock(PostOptionButton, {
          key: 0,
          postId: __props.comment.uuid,
          onDeleteClick: _cache[0] || (_cache[0] = ($event: any) => (emit('delete-click', __props.comment.uuid)))
        }, null, 8, ["postId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})